import { SalesOrderStatus } from 'services/salesOrders';

export const ORDER_STATUS = [
  SalesOrderStatus.Estimate,
  SalesOrderStatus.Issued,
  SalesOrderStatus.Fulfilled,
];
